"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { getCognitoLoginLink } from "@/lib/auth";

export default function SignInCognitoRedirect() {
  const router = useRouter();

  useEffect(() => {
    localStorage.removeItem("notification_filter_settings");
    router.push(getCognitoLoginLink());
  }, [router]);

  return <p>ログインページにリダイレクトしています...</p>;
}